import { useState, useEffect } from 'react'

import ProgressBar from './vacation_events_stats/Progressbar'
import MainStats from './vacation_events_stats/MainStats'
import ShortStats from './vacation_events_stats/ShortStats'

export default function VacationEventsStats (props) {
  const { stats, stats_next_year: statsNextYear } = props

  const [showDetailedNext, setShowDetailedNextYear] = useState(false)
  const [showNextYearMobile, setShowNextYearMobile] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const widthSetter = (showFull) => showFull ? 'detailed-stats-block' : 'short-stats-block'
  const shouldShowDetails = isMobile || showDetailedNext

  return (
    <div className='calendar-events-stats'>
      <div className={`current-year-stats ${widthSetter(!shouldShowDetails)}`}>
        <div className='stats-header'>
          <span>{stats.year}</span>
        </div>
        <ProgressBar stats={stats} />
        <div className='stats-content-block'>
          {(isMobile || !shouldShowDetails) &&
            <MainStats
              stats={stats}
            />}
          <ShortStats
            stats={stats}
            fullView
          />
        </div>
      </div>
      {isMobile
        ? (
          <div className='next-year-stats-mobile'>
            <div className='stats-header'>
              <span>{statsNextYear.year}</span>
              <button type='button' className='show-details' onClick={() => setShowNextYearMobile(prev => !prev)}>
                {I18n.t(`calendar.stats.view_${showNextYearMobile ? 'less' : 'more'}`)}
              </button>
            </div>
            {showNextYearMobile && (
              <>
                <ProgressBar stats={statsNextYear} />
                <div className='stats-content-block'>
                  <MainStats
                    stats={statsNextYear}
                    fullView={false}
                  />
                  <ShortStats
                    stats={statsNextYear}
                    fullView={false}
                  />
                </div>
              </>
            )}
          </div>
          )
        : (
          <div className={`next-year-stats ${widthSetter(shouldShowDetails)}`}>
            <div className='stats-header'>
              <span>{statsNextYear.year}</span>
              <button type='button' className='show-details' onClick={() => setShowDetailedNextYear(prev => !prev)}>
                {I18n.t(`calendar.stats.view_${showDetailedNext ? 'less' : 'more'}`)}
              </button>
            </div>
            <ProgressBar stats={statsNextYear} />
            <div className='stats-content-block'>
              {shouldShowDetails &&
                <MainStats
                  stats={statsNextYear}
                  fullView={false}
                />}
              <ShortStats
                stats={statsNextYear}
                fullView={false}
              />
            </div>
          </div>
          )}
    </div>
  )
}
